
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.724 1.062a.667.667 0 01.61-.396A2.667 2.667 0 0110 3.333v2h3.103a2 2 0 011.996 2.3l-.92 6a2.001 2.001 0 01-1.996 1.7H2.667a2 2 0 01-2-2V8.666a2 2 0 012-2h1.566l2.491-5.604zm-1.39 6.412l2.405-5.412a1.333 1.333 0 01.928 1.27V6c0 .369.298.667.666.667h3.781a.666.666 0 01.667.766l-.92 6a.667.667 0 01-.667.567h-6.86V7.474zM4 14V8H2.667A.667.667 0 002 8.666v4.667a.667.667 0 00.667.666H4z"}})])
          )
        }
      }
    